<template>
  <roe-modal ref="modal" wrap-class="popup-wrap">
    <div class="popup-inner popup-inner--small">
      <div class="popup-header">
        <h4>Terminated Participants</h4>
        <button class="btn-close" @click="$refs.modal.close()"></button>
      </div>
      <div class="popup-content">
        <p>Include terminated participants to the analysis?</p>
        <div class="popup-actions">
          <file-upload
            name="include-terminated"
            class="btn btn-primary"
            @input-file="uploadParticipantsWithTerminated"
          >
            <span>Yes</span>
          </file-upload>
          <file-upload
            name="exclude-terminated"
            class="btn btn-secondary"
            @input-file="uploadParticipantsWithoutTerminated"
          >
            <span>No</span>
          </file-upload>
        </div>
      </div>
    </div>
  </roe-modal>
</template>

<script>
import RoeModal from "@/components/_shared/Modal";
export default {
  name: "RoeIncludeTerminatedModal",
  components: { RoeModal },
  props: {
    validateParticipants: {
      type: Function,
      required: true
    }
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    uploadParticipantsWithTerminated(file) {
      this.$refs.modal.close();
      this.validateParticipants(file, true);
    },
    uploadParticipantsWithoutTerminated(file) {
      this.$refs.modal.close();
      this.validateParticipants(file, false);
    }
  }
};
</script>
